import React from 'react'
import styled from 'react-emotion'
import { css } from 'emotion'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import Helmet from 'react-helmet'

import CategoryList from '../templates/category-list';
import Section from '../components/section/Section'
import Button from '../components/buttons/Button'
import { TwoCol, LeftCol, RightCol, } from '../components/two-col'
import SectionPreHeader from '../components/section/SectionPreHeader'
import SubHeader from '../components/section/SubHeader'
import CalloutContainer from '../components/CalloutContainer'
import HubspotFormSection from '../components/forms/HubspotFormSection'

import seoHero from '../assets/integrations/seo-hero.png'

const CarouselClass = css`
  li.slide {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    filter: grayscale(1);
  }
`

const PartnerCardList = styled.div`
  display: flex;
  flex-wrap: wrap;
`
const PartnerCardWrapper = styled.div`
box-sizing: border-box;
  flex: 1 0 50%;
  max-width: 50%;
  padding: 1rem 0.5rem;

  @media (min-width: 768px) {
    flex: 1 0 33%;
    max-width: 33%;
  }

  @media (min-width: 1200px) {
    flex: 1 0 25%;
    max-width: 25%;
  }
`

const PartnerCardContainer = styled.div`
  text-align: center;
  padding: 1rem;
  background-color: white;
  box-shadow: 0.5rem 0.5rem 0px #18aa7a;
  border: 2px solid #18aa7a;

  a {
    font-size: .8rem;
    padding: .5rem 1rem;
  }

  @media (min-width: 800px) {
    a {
      font-size: 1.1rem;
      padding: 1rem 3rem;
    }
  }
`

const PartnerLogoContainer = styled.div`
  height: 100px;
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 1rem;

  @media (min-width: 800px) {
    height: 200px;
  }
`

const PartnerLogo = styled.img`
  width: 100%;
  width: auto;
  max-height: 100px;
  max-width: 100px;

  @media (min-width: 800px) {
    max-height: 250px;
    max-width: 200px;
  }
`

const PartnerCard = (props) => {
  return (
    <PartnerCardWrapper>
      <PartnerCardContainer>
        <PartnerLogoContainer>
          <PartnerLogo src={props.logo} alt={props.partnerName} />
        </PartnerLogoContainer>
        <Button icon flat to={props.slug}>Read More</Button>
      </PartnerCardContainer>
    </PartnerCardWrapper>
  )
}


class IntegrationsPage extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    console.log(this.props.data)
    return (
      <div>
        <Helmet
          title={'#1 PMS Integration'}
          meta={[
            { name: 'og:title', content: 'Whistle Integrations' },
            { name: 'description', content: 'Integrates in just 24 hours and is 100% cloud based.' },
            { name: 'og:description', content: 'Integrates in just 24 hours and is 100% cloud based.' },
            { name: 'og:image', content: seoHero },
            { name: 'og:type', content: "website" },
            { name: 'og:locale', content: "en_US" },
          ]}
        />
        <TwoCol >
          <LeftCol bgColor={'#18aa7a'} skew color="#fff">
            <SectionPreHeader>Integrations</SectionPreHeader>
            <h1>Whistle's<br/>Powerful<br/>Partnerships</h1>
            <SubHeader>Whistle works seamlessly<br/> with your Property Management<br/> System and can integrate typically<br/> within one business day.</SubHeader>
            <CalloutContainer align={'left'}>
              <Button secondary to="/schedule" icon>Book A Demo</Button>
            </CalloutContainer>
          </LeftCol>
          <RightCol>
            <Carousel
              showArrows={false}
              showIndicators={false}
              showThumbs={false}
              showStatus={false}
              className={CarouselClass}
              infiniteLoop
              autoPlay={() => true}
              interval={2000}
              transitionTime={500}
             >
             {this.props.data.pms.edges.map(partner => (
                <div key={partner.node.id}>
                  <img
                    src={partner.node.frontmatter.logo}
                    alt={partner.node.frontmatter.title}
                    title={partner.node.frontmatter.title}
                    loading="lazy"
                  />
                </div>
              ))}
            </Carousel>
          </RightCol>
        </TwoCol>
      <Section light>
        <CategoryList
          root="integrations"
          categories={this.props.data.categories.group}
        />
        <PartnerCardList>
          {this.props.data.pms.edges.map(partner => (
            <PartnerCard
              key={partner.node.id}
              title={partner.node.frontmatter.title}
              logo={partner.node.frontmatter.logo}
              slug={partner.node.fields.slug}
            />
          ))}
        </PartnerCardList>
      </Section>
        
      <HubspotFormSection
        id="book-demo"
        formId="7d86c04f-e98e-42eb-ae79-ff2b14c7605a"
        trackingId={process.env.ADWORDS_TRACKER_LEAD_FORM}
      />
    </div>
    )
  }
}

export const pageQuery = graphql`
  query IntegrationPartnersQuery($categories: [String]) {
    site {
      siteMetadata {
        title
      }
    }
    categories: allMarkdownRemark(limit: 1000) {
      group(field: frontmatter___integrationCategories) {
        fieldValue
        totalCount
      }
    }
    pms: allMarkdownRemark(
      sort: { order: ASC, fields: [frontmatter___title] },
      filter: { frontmatter: { templateKey: { eq: "integration" }, integrationCategories: { in: $categories } }}
    ) {
      edges {
        node {
          excerpt(pruneLength: 400)
          id
          fields {
            slug
          }
          frontmatter {
            partnerName
            title
            logo
            order
          }
        }
      }
    }
  }
`

 
export default IntegrationsPage;


// WEBPACK FOOTER //
// ./src/templates/integrations.js